import { render } from "./AppNavAccountBtn.vue?vue&type=template&id=6ad3ef78"
import script from "./AppNavAccountBtn.vue?vue&type=script&lang=js"
export * from "./AppNavAccountBtn.vue?vue&type=script&lang=js"
script.render = render

export default script